import type { Tracklist } from "@api/tracklists/types";
import { type ParentComponent, createContext } from "solid-js";
import { createStore } from "solid-js/store";

const [tracklists, setTracklists] = createStore<(Tracklist | undefined)[]>([]);

export const activeFeedContext = createContext({ tracklists, setTracklists });

export const ActiveFeedProvider: ParentComponent = (props) => {
	return (
		<activeFeedContext.Provider value={{ tracklists, setTracklists }}>{props.children}</activeFeedContext.Provider>
	);
};
